// **********************************************************
// Product slider
// **********************************************************

const productCardSwiperElements = document.querySelectorAll('[data-slider="product-slider"]');
const productCardSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    586: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    769: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
  },
};

productCardSwiperElements.forEach((el) => {
  const mainSliderParent = el.closest('.product-slider');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  productCardSliderOptions.navigation.nextEl = arrowRight;
  productCardSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, productCardSliderOptions);
});
